// @ts-ignore
import { Subject } from 'rxjs'
import { useEffect } from 'react'
import toast from 'utilities/toast/toast'
import { useAppDispatch } from 'hooks/useAppDispatch/useAppDispatch'
import { CHANGE_OFFLINE_STATUS } from 'store/reducers/ui/appState.reducer'

/** Track browser offline status, as same as provide way to toggle online/offline status */
function useOfflineTracker() {
    const dispatch = useAppDispatch()

    useEffect(() => {
        function whenOnline() {
            onlineStatusEventBus.next('online')
            dispatch({ type: CHANGE_OFFLINE_STATUS, payload: false })
            toast.success('A connection is back. Turned to online mode.')
        }

        function whenOffline() {
            onlineStatusEventBus.next('offline')
            dispatch({ type: CHANGE_OFFLINE_STATUS, payload: true })
            toast.error('A connection has been lost. Turned to offline mode.')
        }

        window.addEventListener('online', whenOnline)
        window.addEventListener('offline', whenOffline)

        return () => {
            window.removeEventListener('online', whenOnline)
            window.removeEventListener('offline', whenOffline)
        }
    }, [dispatch])
}

export default useOfflineTracker

export type OnlineStatus =
    | 'online'
    | 'offline'
    | 'manual-online'
    | 'manual-offline'

// Use EventBus to broadcast offline/online event
export const onlineStatusEventBus = new Subject<OnlineStatus>()
